import { Component, HostListener, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { database } from 'firebase';

import { Lecture } from '../../lectures/shared/lecture';
import { LectureLessonService } from '../../lectures/shared/lecture-lesson.service';
import { DialogButtonBase } from '../../shared/base/dialog-button-base';
import { QuestionBase } from '../../shared/dynamic-form/shared/question-base';
import { TextboxQuestion } from '../../shared/dynamic-form/shared/question-textbox';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Lesson } from '../shared/lesson';
import { MESSAGE_ADD_LESSON_SUCCESS } from '../shared/lesson-message';
import { LessonService } from '../shared/lesson.service';

@Component({
  selector: 'app-lesson-add-button',
  template: '<ng-content></ng-content>'
})
export class LessonAddButtonComponent extends DialogButtonBase {
  @Input() lecture: Lecture;

  constructor(dialog: MatDialog, snackBar: MatSnackBar, private service: LessonService, private refService: LectureLessonService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  openDialog(): void {
    super.openDialog(this.title, this.questions);
  }

  async onSubmit(value: Lesson): Promise<any> {
    try {
      const newValue = Object.assign(new Lesson(), {
        lecture: this.lecture.$key
      }, value);
      const lesson: database.ThenableReference = await this.service.push(newValue);
      await this.refService.addRef(this.lecture.$key, lesson.key);

      this.closeDialog();
      this.openSnackBar(MESSAGE_ADD_LESSON_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private get title(): string {
    return '학습 목표 생성';
  }

  private get questions(): Array<QuestionBase<any>> {
    return [
      new TextboxQuestion({
        key: 'name',
        label: '제목',
        required: true
      })
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-add-button/lesson-add-button.component.ts